import { MapLayerValidationType } from './map-layer-validation.type';

export class BasketItemLayerModel {
    basketItemId = '';
    mapLayer = '';
    assetPresenceTypeId = 0;
    selected = false;
    validationResult: MapLayerValidationType;
}
